document.addEventListener('DOMContentLoaded', () => {
    // slick default setting
    let defaulsettings = {
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: '.swiper-prev',
            prevEl: '.swiper-next'
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        }     
    };

    // start slider default
    let allSwipper =[];

    document.querySelectorAll('.swiper-slider').forEach((element,i) => {

        let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaulsettings;
        element.setAttribute(`data-swiper-${i}`,"");
        let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig);
        allSwipper[i] = swiper;

    });

    let swiperResidences = new Swiper('.residences__slider',{
        loop: true,
        speed: 700,
        slidesPerView: 3,
        spaceBetween: 25
    });

    let swiperMobileResidences = new Swiper('.residences__slider-mobile',{
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        uniqueNavElements: true,
        pagination: {
            el: '.residences__pagination',
            clickable: true
        },
    });


    let sliderOffers = new Swiper('.slider-offers__slider',{
        loop: true,
        speed: 700,
        effect: 'fade',
        adaptive: 'height',
        allowTouchMove: false,
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            prevEl: '.slider-offers-prev',
            nextEl: '.slider-offers-next'
        },
        on: {
            init: function () {
                let srcActive = document.querySelector('.swiper-slide-next .slider-offers__image img').getAttribute('src');
                let altActive = document.querySelector('.swiper-slide-next .slider-offers__image img').getAttribute('alt');
                document.querySelector('.slider-offers__right img').setAttribute('src', srcActive);
                document.querySelector('.slider-offers__right img').setAttribute('alt', altActive);
            }
        }
    });

    document.querySelectorAll('.slider-offers-prev, .slider-offers-next').forEach((arrow)=>{
        arrow.addEventListener('click', ()=>{
            let src = document.querySelector('.swiper-slide-next .slider-offers__image img').getAttribute('src');
            document.querySelector('.slider-offers__right').classList.remove('show');
            setTimeout(() => {
                document.querySelector('.slider-offers__right').classList.add('show');
                document.querySelector('.slider-offers__right img').setAttribute('src', src);
            }, 200);
        });
    });

    let sliderReviews = new Swiper('.reviews__slider',{
        loop: true,
        speed: 700,
        centeredSlides: true,
        slidesPerView: "auto",
        spaceBetween: 120,
        navigation: {
            prevEl: '.reviews-prev',
            nextEl: '.reviews-next'
        }
    });

    let quadGallery = new Swiper('.gallery-quad__slider',{
        speed: 700,
        centeredSlides: true,
        loop:true,
        spaceBetween: 15,
        slidesPerView: 1.2,
        autoplay: {
            delay: 8000,
            disableOnInteraction: false
        },
        uniqueNavElements: true,
        pagination: {
            el: '.gallery-quad__pagination',
            clickable: true
        },
        breakpoints: {
            700: {
                spaceBetween: 25,
                slidesPerView: 1.4
            }
        }
    });

    let mobileBenefits = new Swiper('.benefits__slider',{
        speed: 700,
        centeredSlides: true,
        loop:true,
        spaceBetween: 25,
        slidesPerView: 1,
        autoplay: {
            delay: 8000,
            disableOnInteraction: false
        },
        uniqueNavElements: true,
        pagination: {
            el: '.benefits__pagination',
            clickable: true
        }
    });

    let slider = new Swiper('.slider__slider',{
        loop: true,
        speed: 700,
        effect: 'fade',
        allowTouchMove: false,
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            prevEl: '.slider-prev',
            nextEl: '.slider-next'
        },
        on: {
            init: function () {
                let srcActive = document.querySelector('.swiper-slide-next .slider__image img').getAttribute('src');
                let altActive = document.querySelector('.swiper-slide-next .slider__image img').getAttribute('alt');
                document.querySelector('.slider__right img').setAttribute('src', srcActive);
                document.querySelector('.slider__right img').setAttribute('alt', altActive);
            }
        }
    });

    document.querySelectorAll('.slider-prev, .slider-next').forEach((arrow)=>{
        arrow.addEventListener('click', ()=>{
            let src = document.querySelector('.swiper-slide-next .slider__image img').getAttribute('src');
            document.querySelector('.slider__right').classList.remove('show');
            setTimeout(() => {
                document.querySelector('.slider__right').classList.add('show');
                document.querySelector('.slider__right img').setAttribute('src', src);
            }, 200);
        });
    });

    let sliderAmenities = new Swiper('.slider-amenities__slider',{
        //loop: true,
        speed: 700,
        slidesPerView: 1,
        // effect: 'fade',
        // fadeEffect: {
        //     crossFade: true
        // },
        navigation: {
            prevEl: '.slider-amenities-prev',
            nextEl: '.slider-amenities-next'
        },
        on: {
            init: function () {
                let textSlideInit = document.querySelector('.slider-amenities__slider .slider-amenities__item.swiper-slide-active').getAttribute('aria-label');
                document.querySelector('.js-counter-amenites').innerHTML = textSlideInit;
            }
        }
    });

    sliderAmenities.on('slideChangeTransitionStart', function () {
        let textSlide = document.querySelector('.slider-amenities__slider .slider-amenities__item.swiper-slide-active').getAttribute('aria-label');
        document.querySelector('.js-counter-amenites').innerHTML = textSlide;
    });

    let carouselslider = new Swiper('.carousel__slider',{
        loop: true,
        speed: 1000,
        centeredSlides: true,
        spaceBetween: 15,
        slidesPerView: 1.2,
        slidesPerGroup: 2,
        autoplay: {
            delay: 8000,
            disableOnInteraction: true
        },
        uniqueNavElements: true,
        pagination: {
            el: '.carousel__pagination',
            clickable: true
        },
        breakpoints: {
            760: {
                slidesPerView: 2,
                spaceBetween: 30
            },
            1280:{
                slidesPerView: 3.5,
                spaceBetween: 15
            }
        }
    })
});

